export enum CountryStatus {
    STANDARD = 'STANDARD',
    BLACKLISTED = 'BLACKLISTED',
    POPULAR = 'POPULAR'
}

export enum InternationalPriceStatus {
    UNAVAILABLE = 'Unavailable',
    FREE = 'Free'
}

export enum InternationalPriceCategories {
    TALK = 'talk',
    TEXT = 'text',
    DATA = 'data'
}

export enum InternationalPriceTypes {
    TO = 'to',
    FROM = 'from'
}
